import styled from 'styled-components';
import { color, ColorProps } from 'styled-system';

export const IconWrapper = styled.span<
  {
    size: number;
  } & ColorProps
>`
  display: inline-flex;
  line-height: 0;
  ${color};

  .svg-inline--fa {
    width: ${({ size }) => (size ? `${size}px` : '100%')};
    height: ${({ size }) => (size ? `${size}px` : '100%')};
  }
`;
